import { Navigate, useParams } from "react-router-dom";
import React, { useContext } from "react";
import AuthContext from "./../context/Authcontext";
import axios from "axios";





const ProtectedRoute = ({ children }) => {
  const { contextData } = useContext(AuthContext);
  let user = contextData.user;
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AdminTeacherrouteRoute = ({ children }) => {

  const { contextData } = useContext(AuthContext);

  let user = contextData.user;
  if (!user || !(user.role === "admin" || user.role === "teacher")) {
    return <Navigate to="/notallowed" replace />;
  }

  return children;
};


export default ProtectedRoute;
export { AdminTeacherrouteRoute };

